import script from "./Sub4.vue?vue&type=script&setup=true&lang=ts"
export * from "./Sub4.vue?vue&type=script&setup=true&lang=ts"

import "./Sub4.vue?vue&type=style&index=0&id=004d84c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-004d84c8"]])

export default __exports__